module.exports = __webpack_public_path__ + "img/back-arrow.625b9bee.svg";